import React from "react"

import SEO from "@components/SEO/SEO"
import DefaultPrefooter from "@components/prefooters/DefaultPrefooter/DefaultPrefooter"

import DEIPageDemographicsSection from "./_components/DEIPageDemographicsSection/DEIPageDemographicsSection"
import DEIPageTeamsSection from "./_components/DEIPageTeamsSection/DEIPageTeamsSection"
import DEIPageFullTeamGender from "./_components/DEIPageFullTeamGender/DEIPageFullTeamGender"
import DEIPageFullTeamRace from "./_components/DEIPageFullTeamRace/DEIPageFullTeamRace"
import DEIPageHero from "./_components/DEIPageHero/DEIPageHero"
import DEIPagePrinciplesSection from "./_components/DEIPagePrinciplesSection/DEIPagePrinciplesSection"
import DEIPageFurtherReadingSection from "./_components/DEIPageFurtherReadingSection/DEIPageFurtherReadingSection"
import { graphql, useStaticQuery } from "gatsby"
import { DeiPageQueryQuery } from "@graphqlTypes"

export const Head = () => (
  <SEO
    description="We believe that when teams represent different backgrounds, perspectives, and experiences, magic happens — we create better products and cultivate a culture that enables everyone to bring their authentic selves to work."
    image="/images/pages/dei/DEIPage--meta.png"
    permalink="/dei/"
    title="Diversity, Equity & Inclusion at Help Scout"
  />
)

const DEIPage = () => {
  const { contentfulJsonData } = useStaticQuery<DeiPageQueryQuery>(graphql`
    query DEIPageQuery {
      contentfulJsonData(contentful_id: {eq: "wzO7jxl2FLvNWH10sJv6z"}) {
        json {
          fullTeam {
            race {
              title
              dates {
                title
                footnote
                percentages {
                  title
                  percentage
                }
              }
            }
            gender {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            age {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            physicalDisability {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            neurodivergent {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            parentsGuardians {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            lgbq {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            transgender {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            education {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            veterans {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
          }
          teams {
            title
            race {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
            gender {
              title
              dates {
                title
                percentages {
                  title
                  percentage
                }
              }
            }
          }
        }
      }
    }
  `)

  if (!contentfulJsonData?.json) return null

  return (
    <>
      <DEIPageHero />
      <DEIPagePrinciplesSection />
      {contentfulJsonData.json.fullTeam?.race && <DEIPageFullTeamRace race={contentfulJsonData.json.fullTeam?.race} />}
      {contentfulJsonData.json.fullTeam?.gender && <DEIPageFullTeamGender gender={contentfulJsonData.json.fullTeam?.gender} />}
      {contentfulJsonData.json.fullTeam && <DEIPageDemographicsSection fullTeam={contentfulJsonData.json.fullTeam} />}
      {contentfulJsonData.json.teams && <DEIPageTeamsSection teams={contentfulJsonData.json.teams} />}
      <DEIPageFurtherReadingSection />
      <DefaultPrefooter />
    </>
  )
}

export default DEIPage
